export const topics = [
  {
    header: 'Taxes',
    subtitles: 'Do your taxes',
    description: 'Finish you taxes',
    link: '/taxes',
  },
  {
    header: 'Immigration',
    subtitles: 'Immigrate to Portugal!',
    description: 'Super easy. Click here!',
    link: '/immigration',
  },
  {
    header: 'School',
    subtitles: 'Wow',
    description: 'Children',
    link: '/school',
  },
];
